module.exports = __webpack_public_path__ + "static/media/stephen-hailey.cffad3c6.md";